/**
 * YearTabs — segmented control for selecting a target graduation year.
 * Matches detail-atoms.jsx YearTabs.
 */
import React from 'react';

interface Props {
  years: readonly number[];
  active: number;
  dense?: boolean;
  onChange: (year: number) => void;
}

export function YearTabs({ years, active, dense = false, onChange }: Props) {
  return (
    <div
      className="inline-flex items-stretch bg-surface-sunken rounded-md p-[3px] max-w-full flex-wrap"
      role="group"
      aria-label="Select target graduation year"
    >
      {years.map((y) => {
        const isActive = y === active;
        return (
          <button
            key={y}
            type="button"
            role="radio"
            aria-checked={isActive}
            onClick={() => onChange(y)}
            className={[
              dense ? 'px-2.5 py-1 text-xs' : 'px-2.5 py-1.5 text-[13px] min-h-[44px] min-w-[48px]',
              'rounded font-tabular-nums focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary',
              'motion-safe:transition-colors',
              isActive
                ? 'bg-surface-card text-gray-900 font-bold shadow-sm'
                : 'text-gray-600 font-medium hover:text-gray-800 bg-transparent',
            ].join(' ')}
          >
            {y}
          </button>
        );
      })}
    </div>
  );
}
